<script>
    import {getGPTransFunc} from "./gp-translations.js";
    import jQuery from "jquery";
    import {activePickerItem, GPContextItems} from "./gp-context-items";
    import {textFilter, typeFilter, sizeFilter, lightFilter, colorFilter, seasonFilter} from "./gp-plantpickerstore.js";
    import {soilSettings, season, preferredNames} from './gp.js';
    import {tick} from 'svelte';
    import GPPlantItem from "./gp-plantpickeritem.svelte"
    import {flip} from 'svelte/animate';
    import { onMount } from 'svelte';
    import {GPTypePlant} from "./gp-typeplant";

    export let plants;
    let trans = getGPTransFunc("gp-plantpicker");
    let initialItemsLimit = 50;
    let itemsLimit = 50;
    let itemsVisibleCount;
    let overLimitCount;
    $: {
        jQuery("#GPPlantPickerList").animate({ scrollTop: 0 }, "fast");
        itemsLimit = initialItemsLimit;
        update($textFilter, $typeFilter, $sizeFilter, $lightFilter, $colorFilter, $seasonFilter, $season, $preferredNames, $soilSettings)
    }

    let elemsInRow = null;

    onMount(() => {
        jQuery(window).off('resize', onResize);
        jQuery(window).on('resize', onResize);

        var chk_scroll = function (e) {
            var elem = jQuery(e.currentTarget);
            if (elem[0].scrollHeight - elem.scrollTop() - 10 < elem.outerHeight()) loadMore();
        };
        jQuery('#GPPlantPickerList').bind('scroll', chk_scroll);

        if (!$activePickerItem || !($activePickerItem instanceof GPTypePlant)) selectFirstItem();

        onResize();
    })

    export function update() {
        let allFittingCount = 0;
        plants = plants.map((el, i) => {
            el.visible = true;

            let filterLightMapping = {
                "filterAll": null,
                "filterSun": "light_full",
                "filterSunHalf": "light_half",
                "filterSunNone": "light_dark"
            };

            let filterTypeMapping = {
                "filterAll": null,
                "filterAzalia": "azalia",
                "filterConifer": "conifer",
                "filterTreeLeafy": "tree_leafy",
                "filterSeed": "seed",
                "filterFlower": "flower",
                "filterBushLeafy": "bush_leafy",
                "filterCreeper": "creeper",
                "filterVegetables": "vegetable,herbs"
            };

            let filterSizeMapping = {
                "filterAll": null,
                "filterSmall": {"min": 0, "max": 80},
                "filterMedium": {"min": 80, "max": 200},
                "filterBig": {"min": 200, "max": 99999}
            };

            let filterSeasonMapping = {
                "filterAll": null,
                "filter1": 1,
                "filter2": 2,
                "filter3": 3,
                "filter4": 4,
                "filter5": 5,
                "filter6": 6,
                "filter7": 7,
                "filter8": 8,
                "filter9": 9,
                "filter10": 10,
                "filter11": 11,
                "filter12": 12
            };

            let filterColorMapping = {
                "filterAll": null,
                "filterRed": "czerwone",
                "filterYellow": "żółte",
                "filterBlue": "niebieskie",
                "filterWhite": "białe",
                "filterPink": "różowe",
                "filterOrange": "pomarańczowe"
            };

            if ($textFilter) {
                //format searched pattern
                var nameCandidates = [el.name];
                if ((el.altname1 || "").length > 0) nameCandidates.push(el.altname1);
                if ((el.altname2 || "").length > 0) nameCandidates.push(el.altname2);
                if ((el.altname3 || "").length > 0) nameCandidates.push(el.altname3);
                if ((el.altname4 || "").length > 0) nameCandidates.push(el.altname4);
                if ((el.altname5 || "").length > 0) nameCandidates.push(el.altname5);
                if ((el.latin || "").length > 0) nameCandidates.push(el.latin);
                let res = searchAndFormat($textFilter.toLowerCase(), nameCandidates);
                if (!res)
                    el.visible = false
                else
                    el.displayName = res;
            } else {
                if ($preferredNames === "latin")
                    el.displayName = el.latin;
                else
                    el.displayName = el.name;
            }


            if (el.visible && $lightFilter && filterLightMapping[$lightFilter] && el[filterLightMapping[$lightFilter]] !== 1) el.visible = false;
            if (el.visible && $typeFilter && filterTypeMapping[$typeFilter] && filterTypeMapping[$typeFilter].indexOf(el.type) < 0) el.visible = false;
            if (el.visible && $typeFilter && $typeFilter === "filterExtraPackage" && el.package !== "extra") el.visible = false;
            if (el.visible && $colorFilter && filterColorMapping[$colorFilter] &&
                el.flower_color.indexOf(filterColorMapping[$colorFilter]) < 0 &&
                el.leaf_color.indexOf(filterColorMapping[$colorFilter]) < 0 ) el.visible = false;
            if (el.visible && $sizeFilter && filterSizeMapping[$sizeFilter]) {
                if ((parseInt(el.height) < filterSizeMapping[$sizeFilter].min) ||
                    (parseInt(el.height) > filterSizeMapping[$sizeFilter].max))
                    el.visible = false;
            }
            if (el.visible && $seasonFilter && filterSeasonMapping[$seasonFilter]) {
                if (!el.blossom_from || !el.blossom_to ||
                    (el.blossom_from > filterSeasonMapping[$seasonFilter]) ||
                    (el.blossom_to < filterSeasonMapping[$seasonFilter]))
                    el.visible = false;
            }

            if (el.visible) {
                allFittingCount += 1;
            }
            return el;
        });
        resortPlants();

        itemsVisibleCount = 0;
        plants = plants.map((el, i) => {
            if (itemsVisibleCount > itemsLimit) el.visible = false;
            if (el.visible) {
                itemsVisibleCount += 1;
            }

            el.fitsToProject = !(GP.project && !GP.project.plantFitsTo(el));
            el.fitsToSeason = el['season_'+ el.staticMapMonth2Season($season)] && el['season_'+el.staticMapMonth2Season($season)].length;
            return el;
        });
        overLimitCount = allFittingCount - itemsVisibleCount;
    }

    function resortPlants () {
        var sizePreference = {"B":"A","A":"B","C":"B"}; // medium project: first medium plants, later whatever
        let dw = GP.project ? GP.project.designWidth : 7;
        if (dw < 7) sizePreference = {"A":"A","B":"B","C":"C"}; //small projects, order by size
        if (dw > 9) sizePreference = {"A":"C","B":"B","C":"A"}; //big projects, order by size desc

        plants.sort(function (a, b) {
            var an = a.name.replace("'","");
            var bn = b.name.replace("'","");
            var asizeCategory = "B"; if (a.height<80) asizeCategory = "A"; if (a.height>200) asizeCategory = "C";
            var bsizeCategory = "B"; if (b.height<80) bsizeCategory = "A"; if (b.height>200) bsizeCategory = "C";
            an = sizePreference[asizeCategory] + an;
            bn = sizePreference[bsizeCategory] + bn;
            if (GP.project && GP.project.plantFitsTo(a)) an = "A"+an; else an = "Z"+an;
            if (GP.project && GP.project.plantFitsTo(b)) bn = "A"+bn; else bn = "Z"+bn;
            if (!a.enabled) an = "Z"+an; else an = "A"+an;
            if (!b.enabled) bn = "Z"+bn; else bn = "A"+bn;
            if (an < bn)
                return -1;
            if (an > bn)
                return 1;
            return 0;
        });
    }

    function loadMore(uptoIdx) {
        if (overLimitCount === 0) return;
        let addAmount = uptoIdx ? uptoIdx : initialItemsLimit;
        itemsLimit += addAmount;
        update();
    }

    function loadUntil(plantId) {
        let idx;
        plants.forEach((el, i) => {
            if (parseInt(el.id) == parseInt(plantId)) idx = i;
        })
        if (idx) loadMore(idx + 1);
    }

    function selectItem(plant) {
        if (plant && plant.enabled)
            $activePickerItem = plant;
    }

    export async function selectFirstItem() {
        await tick();
        selectItem(plants.filter((e) => e.visible)[0]);
        scrollToSelected();
    }

    function scrollToSelected() {
        setTimeout(async () => {
            await tick();
            if (jQuery(".GPPlantPickerItem").length) { //this additional check is need, because event can fire this function even when component is umoun
                let el = jQuery('.GPPlantPickerItem.selected');
                if (el) {
                    let main = jQuery("#GPPlantPickerList");
                    let top = jQuery(".GPPlantPickerItem").eq(0).parent().position().top;
                    let t = el.position().top;
                    main.animate({scrollTop: -top + t}, 100);
                }
            }
        }, 500)
    }

    function selectNextItem(step) {
        let displayedObjs = plants.filter((e) => e.visible && e.enabled);
        let newActiveIndex = displayedObjs.indexOf($activePickerItem) + step;
        if (newActiveIndex >= displayedObjs.length) newActiveIndex = displayedObjs.length - 1;
        $activePickerItem = displayedObjs[newActiveIndex];
        scrollToSelected();
    }

    function selectPrevItem(step) {
        let displayedObjs = plants.filter((e) => e.visible && e.enabled);
        let newActiveIndex = displayedObjs.indexOf($activePickerItem) - step;
        if (newActiveIndex < 0) newActiveIndex = 0;
        $activePickerItem = displayedObjs[newActiveIndex];
        scrollToSelected();
    }

    function handleKeyboard(e) {
        if (!$activePickerItem || !(jQuery(".GPPickerArea.active").length)) return;
        switch (e.which) {
            case 37: // left
                selectPrevItem(1);
                break;

            case 38: // up
                selectPrevItem(elemsInRow);
                break;

            case 39: // right
                selectNextItem(1);
                break;

            case 40: // down
                selectNextItem(elemsInRow);
                break;

            case 32: // space
                GPContextItems.addItemAtDefaultPos();
                break;

            case 191: // ?
                GP.app.showDetailsOfItem($activePickerItem);
                break;

            default:
                return; // exit this handler for other keys
        }
        e.preventDefault(); // prevent the default action (scroll / move caret)
    }

    function searchAndFormat (pattern, candidateArray) {
        var cand, i, pos;
        for (i in candidateArray) {
            cand = candidateArray[i];
            pos = cand.toLowerCase().indexOf(pattern);
            if (pos >= 0) {
                return cand.substr(0,pos) + '<b>' + cand.substr(pos,pattern.length) + '</b>' + cand.substr(pos+pattern.length);
            }
        }
        return false;
    }

    async function resetPicker() {
        $textFilter = "";
        $typeFilter = "filterAll";
        $sizeFilter = "filterAll";
        $lightFilter = "filterAll";
        $colorFilter = "filterAll";
        $seasonFilter = "filterAll";
        await tick();
        selectFirstItem();
    }


    export async function findAndSelect(itemInstance) {
        $textFilter = "";
        $typeFilter = "filterAll";
        $sizeFilter = "filterAll";
        $lightFilter = "filterAll";
        $colorFilter = "filterAll";
        $seasonFilter = "filterAll";
        await tick();
        $activePickerItem = itemInstance.data;
        loadUntil($activePickerItem.id);
        await tick();
        scrollToSelected();
    }

    export function onResize() {
        var pickerW = jQuery('.GPPickerArea').innerWidth();
        elemsInRow = Math.floor(pickerW / 110);
        jQuery('#GPPlantPickerList').css('grid-template-columns', 'repeat(' + elemsInRow + ', 1fr)');
    }

</script>

<svelte:window on:keydown={handleKeyboard} on:GPNewProject={resetPicker}/>

{#each plants.filter(el => el.visible) as plant (plant.id)}
    <li animate:flip={{duration: 200}}>
        <GPPlantItem plant={plant}/>
    </li>
{/each}

{#if overLimitCount > 0}
    <li class="list-group-item GPPlantPickerItem " on:click={loadMore}>
        <div class="GPPlantPickerMoreAvailable">
            + {overLimitCount} {trans( "more")}<br/>
            {trans( "click to load more or use filters")}
        </div>
    </li>
{/if}

{#if itemsVisibleCount === 0}
    <li class="list-group-item GPPlantPickerItem ">
        <div class="GPPlantPickerEmptyResult">
            {trans( "No items matching")}. <a
                on:click={resetPicker}
                class="clearFilters">{trans( "Clear filters")}</a>
        </div>
    </li>
{/if}
